/**
 * Contains common code for VariablesTab store
 */

import { ContainerTabStoreBase } from "DistributedTaskControls/SharedViews/ContainerTabs/ContainerTabStoreBase";

export abstract class VariablesTabStoreBase extends ContainerTabStoreBase {
}